"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRK_PRODUCT_LOCATION = exports.LINK_TYPES = void 0;
var LINK_TYPES = {
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
exports.LINK_TYPES = LINK_TYPES;
var TRK_PRODUCT_LOCATION = 'MarketplaceReviewLink';
exports.TRK_PRODUCT_LOCATION = TRK_PRODUCT_LOCATION;